function generateIdFromProducto(producto) {
    return `${producto.nombre}-${producto.categoria}`
      .toLowerCase()
      .replace(/\s+/g, '-')       
      .replace(/[^a-z0-9-]/g, ''); 
  }
  function limpiarTextoParaSlug(texto) {
    return texto
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") 
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-') 
      .replace(/[^a-z0-9-]/g, ''); 
  }

const panelesDecorativos = [
  {
    nombre: "Panel tipo media luna",
    categoria: "Paneles Decorativos",
    linea: "PS",
    codigos: ["M04-009", "M04-023"],
    modelos: ["Nogal", "Arce"],
    colores: ["Nogal", "Arce"],
    images: [
      require("../../assets/img/productos/paneles/mediaLuna/muestra.jpg"),
      require("../../assets/img/productos/paneles/mediaLuna/nogal.jpg"),
      require("../../assets/img/productos/paneles/mediaLuna/arce.jpg"),
    ],
    dimensiones: "15 x 290 cm",
    dimensionesTransversales: "150 mm x 10 mm",
    piezasPorCaja: 24,
    metrosLinealesCaja: 69.6,
    metrosCuadradosCaja: 10.44,
    metrosLinealesPorPieza: 2.9,
    metrosCuadradosPorPieza: 0.44,
    material: "PS",
    detalles: [
      "Detalles dorados",
      "Uso interior"
    ],
    aplicaciones: [
      "Muros decorativos",
      "Interiores"
    ],
    notas: [
      "No incluye accesorios para instalación.",
      "Disponibilidad de envío según zona."
    ]
  },

  {
    nombre: "Panel tipo piedra",
    categoria: "Paneles Decorativos",
    linea: "PU",
    codigos: ["S7-15", "S9-15", "S7-5", "S9-5"],
    modelos: ["S7 Ivory", "S9 Ivory", "S7 Grey", "S9 Grey"],
    colores: ["Ivory", "Grey"],
    images: [
      require("../../assets/img/productos/paneles/piedra/muestra.jpg"),
      require("../../assets/img/productos/paneles/piedra/ivory.jpg"),
      require("../../assets/img/productos/paneles/piedra/grey.jpg")
    ],
    dimensiones: "120 x 60 cm",
    piezasPorCaja: 10,
    metrosCuadradosCaja: 7.20,
    metrosCuadradosPorPieza: 0.72,
    material: "PU",
    aplicaciones: [
      "Muros decorativos",
      "Interiores",
      "Exteriores protegidos"
    ],
    notas: [
      "No incluye accesorios para instalación.",
      "Disponibilidad de envío según zona."
    ]
  },

  {
    nombre: "Placa tipo mármol",
    categoria: "Paneles Decorativos",
    linea: "PVC Mármol",
    colecciones: {
      teknoStep: {
        modelos: [
          { codigo: "020", nombre: "Arena" },
          { codigo: "006", nombre: "Zafiro" },
          { codigo: "042", nombre: "Perla" },
          { codigo: "014", nombre: "Grafito" }
        ]
      },
      hiBlinds: {
        modelos: [
          { codigo: "S1646", nombre: "Akal" },
          { codigo: "S1641", nombre: "Cinza" },
          { codigo: "S1658", nombre: "Obsidiana" },
          { codigo: "ZT188", nombre: "Barita" },
          { codigo: "ZT238", nombre: "Nero" }
        ]
      }
    },
    colores: [
      "Arena",
      "Zafiro",
      "Perla",
      "Grafito",
      "Akal",
      "Cinza",
      "Obsidiana",
      "Barita",
      "Nero"
    ],
    images: [
      require("../../assets/img/productos/paneles/marmol/muestra.jpg"),
      require("../../assets/img/productos/paneles/marmol/arena.jpg"),
      require("../../assets/img/productos/paneles/marmol/zafiro.jpg"),
      require("../../assets/img/productos/paneles/marmol/perla.jpg"),
      require("../../assets/img/productos/paneles/marmol/grafito.jpg"),
      require("../../assets/img/productos/paneles/marmol/akal.jpg"),
      require("../../assets/img/productos/paneles/marmol/cinza.jpg"),
      require("../../assets/img/productos/paneles/marmol/obsidiana.jpg"),
      require("../../assets/img/productos/paneles/marmol/barita.jpg"),
      require("../../assets/img/productos/paneles/marmol/nero.jpg")
    ],
    dimensiones: "122 x 244 cm",
    metrosCuadradosPorPieza: 2.98,
    material: "PVC",
    acabado: "Imitación mármol",
    aplicaciones: [
      "Muros decorativos",
      "Interiores"
    ],
    notas: [
      "No incluye accesorios para instalación.",
      "Disponibilidad de envío según zona."
    ]
  }
].map(producto => ({
  ...producto,
  id: generateIdFromProducto(producto),
  slug: limpiarTextoParaSlug(`${producto.nombre}-${producto.categoria}`),
  categoriaSlug: limpiarTextoParaSlug(producto.categoria)
}));

export default panelesDecorativos;